import React from 'react';
import { Form, Input } from 'antd';

const HerbItem: React.FC<any> = ({ prefix }) => {
  return (
    <div>
      <Form.Item
        name={[...prefix, 'title']}
        label={`名称`}
        rules={[{ required: true, message: '不能为空' }]}
      >
        <Input placeholder={`请输入名称`} />
      </Form.Item>
    </div>
  );
};
export default HerbItem;